import { SpinnerElement } from './Spinner.styles';
import type { SpinnerProps } from './Spinner.types';

export function Spinner({
  size = 16,
  tone = 'inverse',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}: SpinnerProps) {
  return (
    <SpinnerElement
      $size={size}
      data-tone={tone}
      role={ariaLabel ? 'status' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    />
  );
}
